import "../style/dark.scss";
import { useState, useEffect, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Home from "../components/home/Home";
import LoginPage from "../pages/login/LoginPage";
import Navbar from "../components/navbar/Navbar";
import Sidebar from "../components/sidebar/Sidebar";
import { DarkModeContext } from "../context/darkModeContext";

import { ArticulosFormPage } from "../pages/articulos/articulosForm/ArticulosFormPage";
import { BarriosFormPage } from "../pages/barrios/barriosForm/BarriosFormPage";
import { ClientesFormPage } from "../pages/clientes/clientesForm/clientesFormPage";
import { ColoresFormPage } from "../pages/colores/coloresForm/coloresFormPage";
import { DescuentosFormPage } from "../pages/descuentos/descuentosForm/descuentosFormPage";
import { DepartamentosFormPage } from "../pages/departamentos/departamentosForm/DepartamentosFormPage";
import { DepositosFormPage } from "../pages/depositos/depositosForm/DepositosFormPage";
import { DocumentosFormPage } from "../pages/documentos/documentosForm/DocumentosFormPage";
import { EmpleadosFormPage } from "../pages/empleados/empleadosForm/empleadosFormPage";
import { EmpresaFormPage } from "../pages/empresa/empresaForm/empresaFormPage";
import { InventariosCabFormPage } from "../pages/inventarioscab/inventariosCabForm/InventariosCabFormPage";
import { LocalidadesFormPage } from "../pages/localidades/localidadesForm/LocalidadesFormPage";
import { ListasCabFormPage } from  "../pages/listascab/listasCabForm/ListasCabFormPage";
import { MedidasFormPage } from "../pages/medidas/medidasForm/medidasFormPage";
import { MarcasFormPage } from "../pages/marcas/marcasForm/marcasFormPage";
import { ModelosFormPage } from "../pages/modelos/modelosForm/modelosFormPage";
import { OfertasCabFormPage } from "../pages/ofertascab/ofertasCabForm/OfertasCabFormPage";
import { PedidosFormPage } from "../pages/pedidos/PedidosForm/PedidosFormPage";
import { PedidosHistorialFormPage } from "../pages/pedidoshistorial/PedidosHistorialForm/PedidosHistorialFormPage";
import { ProvinciasFormPage } from "../pages/provincias/provinciasForm/ProvinciasFormPage";
import { PresentacionesFormPage } from "../pages/presentaciones/presentacionesForm/presentacionesFormPage";
import { RamosFormPage } from "../pages/ramos/ramosForm/RamosFormPage";
import { RolesFormPage } from "../pages/roles/rolesForm/RolesFormPage";
import { RubrosFormPage } from "../pages/rubros/rubrosForm/RubrosFormPage";
import { SubrubrosFormPage } from "../pages/subrubros/subrubrosForm/SubrubrosFormPage";
import { SucursalesFormPage } from "../pages/sucursales/sucursalesForm/SucursalesFormPage";
import { TallesFormPage } from "../pages/talles/tallesForm/tallesFormPage";
import { TemporadasFormPage } from "../pages/temporadas/temporadasForm/temporadasFormPage";
import { VisitasFormPage } from "../pages/visitas/visitasForm/visitasFormPage";
import { BannersFormPage } from "../pages/banners/bannersForm/bannersFormPage";
import { SlidersFormPage } from "../pages/sliders/slidersForm/slidersFormPage";
import { ThemeFormPage } from "../pages/theme/themeForm/themeFormPage";
import { ZonasFormPage } from "../pages/zonas/zonasForm/zonasFormPage";



import ArticulosPage from "../pages/articulos/ArticulosPage";
import ArticulosDepositoPage from "../pages/articulosDeposito/ArticulosDepositoPage";
import BarriosPage from "../pages/barrios/BarriosPage";
import ClientesPage from "../pages/clientes/clientesPage";
import ColoresPage from "../pages/colores/coloresPage";
import DescuentosPage from "../pages/descuentos/descuentosPage";
import DepartamentosPage from "../pages/departamentos/DepartamentosPage";
import DepositosPage from "../pages/depositos/DepositosPage";
import DocumentosPage from "../pages/documentos/DocumentosPage";
import EmpresaPage from "../pages/empresa/empresaPage";
import EmpleadosPage from "../pages/empleados/empleadosPage";
import InventariosCabPage from "../pages/inventarioscab/InventariosCabPage";
import ListasCabPage from "../pages/listascab/ListasCabPage";
import LocalidadesPage from "../pages/localidades/LocalidadesPage";
import MarcasPage from "../pages/marcas/marcasPage";
import MedidasPage from "../pages/medidas/medidasPage";
import ModelosPage from "../pages/modelos/modelosPage";
import OfertasCabPage from "../pages/ofertascab/OfertasCabPage";
import PedidosPage from "../pages/pedidos/PedidosPage";
import PedidosHistorialPage from "../pages/pedidoshistorial/PedidosHistorialPage";
import ProvinciasPage from "../pages/provincias/ProvinciasPage";
import PresentacionesPage from "../pages/presentaciones/presentacionesPage";
import RamosPage from "../pages/ramos/RamosPage";
import RolesPage from "../pages/roles/RolesPage";
import RubrosPage from "../pages/rubros/RubrosPage";
import SubrubrosPage from "../pages/subrubros/SubrubrosPage";
import SucursalesPage from "../pages/sucursales/SucursalesPage";
import TallesPage from "../pages/talles/tallesPage";
import TemporadasPage from "../pages/temporadas/temporadasPage";
import VisitasPage from "../pages/visitas/visitasPage";
import VisitasMapsPage from "../pages/visitas/visitasMapsPage";
import BannersPage from "../pages/banners/bannersPage";
import SlidersPage from "../pages/sliders/slidersPage";
import ThemePage from "../pages/theme/themePage";
import ZonasPage from "../pages/zonas/ZonasPage";

const AppRoutes = () => {
  const { darkMode } = useContext(DarkModeContext);

  // Sidebar abierto por defecto al ingresar
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const toggleSidebar = () => setSidebarVisible((prev) => !prev);
  const closeSidebar = () => setSidebarVisible(false);

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") closeSidebar(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

    // Sincronizar dark/light al body para que los modales/portales hereden el tema
  useEffect(() => {
    document.body.classList.toggle("dark",  darkMode);
    document.body.classList.toggle("light", !darkMode);
  }, [darkMode]);
  
  return (
    <div className={`test ${darkMode ? "dark" : "light"}`}>
      <Routes>
        {/* Pública */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protegidas */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              {/* Overlay — click fuera cierra el sidebar */}
              {sidebarVisible && (
                <div className="sidebar-overlay" onClick={closeSidebar} />
              )}

              {/* Sidebar flotante (fixed en CSS) */}
              <Sidebar visible={sidebarVisible} />

              {/* Contenido — ocupa toda la pantalla */}
              <div className="listContainer">
                <Navbar toggleSidebar={toggleSidebar} sidebarVisible={sidebarVisible} />

                <Routes>
                  <Route index element={<Home />} />

                  <Route path="ramos" element={<RamosPage />} />
                  <Route path="ramos/new" element={<RamosFormPage />} />
                  <Route path="ramos/new/:id" element={<RamosFormPage />} />

                  <Route path="rubros" element={<RubrosPage />} />
                  <Route path="rubros/new" element={<RubrosFormPage />} />
                  <Route path="rubros/new/:id" element={<RubrosFormPage />} />

                  <Route path="subrubros" element={<SubrubrosPage />} />
                  <Route path="subrubros/new" element={<SubrubrosFormPage />} />
                  <Route path="subrubros/new/:id" element={<SubrubrosFormPage />} />

                  <Route path="marcas" element={<MarcasPage />} />
                  <Route path="marcas/new" element={<MarcasFormPage />} />
                  <Route path="marcas/new/:id" element={<MarcasFormPage />} />

                  <Route path="colores" element={<ColoresPage />} />
                  <Route path="colores/new" element={<ColoresFormPage />} />
                  <Route path="colores/new/:id" element={<ColoresFormPage />} />

                  <Route path="modelos" element={<ModelosPage />} />
                  <Route path="modelos/new" element={<ModelosFormPage />} />
                  <Route path="modelos/new/:id" element={<ModelosFormPage />} />

                  <Route path="medidas" element={<MedidasPage />} />
                  <Route path="medidas/new" element={<MedidasFormPage />} />
                  <Route path="medidas/new/:id" element={<MedidasFormPage />} />

                  <Route path="presentaciones" element={<PresentacionesPage />} />
                  <Route path="presentaciones/new" element={<PresentacionesFormPage />} />
                  <Route path="presentaciones/new/:id" element={<PresentacionesFormPage />} />

                  <Route path="talles" element={<TallesPage />} />
                  <Route path="talles/new" element={<TallesFormPage />} />
                  <Route path="talles/new/:id" element={<TallesFormPage />} />

                  <Route path="temporadas" element={<TemporadasPage />} />
                  <Route path="temporadas/new" element={<TemporadasFormPage />} />
                  <Route path="temporadas/new/:id" element={<TemporadasFormPage />} />

                  <Route path="articulos" element={<ArticulosPage />} />
                  <Route path="articulos/new" element={<ArticulosFormPage />} />
                  <Route path="articulos/new/:id" element={<ArticulosFormPage />} />

                  <Route path="ofertas" element={<OfertasCabPage />} />
                  <Route path="ofertas/new" element={<OfertasCabFormPage />} />
                  <Route path="ofertas/new/:id" element={<OfertasCabFormPage />} />
                  
                  <Route path="listas" element={<ListasCabPage />} />
                  <Route path="listas/new" element={<ListasCabFormPage />} />
                  <Route path="listas/new/:id" element={<ListasCabFormPage />} />

                  <Route path="pedidos" element={<PedidosPage />} />
                  <Route path="pedidos/new" element={<PedidosFormPage />} />
                  <Route path="pedidos/new/:id" element={<PedidosFormPage />} />

                  <Route path="pedidosHistorial" element={<PedidosHistorialPage />} />
                  <Route path="pedidosHistorial/new" element={<PedidosHistorialFormPage />} />
                  <Route path="pedidosHistorial/new/:id" element={<PedidosHistorialFormPage />} />

                  <Route path="provincias" element={<ProvinciasPage />} />
                  <Route path="provincias/new" element={<ProvinciasFormPage />} />
                  <Route path="provincias/new/:id" element={<ProvinciasFormPage />} />

                  <Route path="departamentos" element={<DepartamentosPage />} />
                  <Route path="departamentos/new" element={<DepartamentosFormPage />} />
                  <Route path="departamentos/new/:id" element={<DepartamentosFormPage />} />

                  <Route path="localidades" element={<LocalidadesPage />} />
                  <Route path="localidades/new" element={<LocalidadesFormPage />} />
                  <Route path="localidades/new/:id" element={<LocalidadesFormPage />} />

                  <Route path="barrios" element={<BarriosPage />} />
                  <Route path="barrios/new" element={<BarriosFormPage />} />
                  <Route path="barrios/new/:id" element={<BarriosFormPage />} />

                  <Route path="empleados" element={<EmpleadosPage />} />
                  <Route path="empleados/new" element={<EmpleadosFormPage />} />
                  <Route path="empleados/new/:id" element={<EmpleadosFormPage />} />

                  <Route path="empresa" element={<EmpresaPage />} />
                  <Route path="empresa/new" element={<EmpresaFormPage />} />
                  <Route path="empresa/new/:id" element={<EmpresaFormPage />} />

                  <Route path="banners" element={<BannersPage />} />
                  <Route path="banners/new" element={<BannersFormPage />} />
                  <Route path="banners/new/:id" element={<BannersFormPage />} />

                  <Route path="sliders" element={<SlidersPage />} />
                  <Route path="sliders/new" element={<SlidersFormPage />} />
                  <Route path="sliders/new/:id" element={<SlidersFormPage />} />

                  <Route path="clientes" element={<ClientesPage />} />
                  <Route path="clientes/new" element={<ClientesFormPage />} />
                  <Route path="clientes/new/:id" element={<ClientesFormPage />} />

                  <Route path="zonas" element={<ZonasPage />} />
                  <Route path="zonas/new" element={<ZonasFormPage />} />
                  <Route path="zonas/new/:id" element={<ZonasFormPage />} />

                  <Route path="inventarios" element={<InventariosCabPage />} />
                  <Route path="inventarios/new" element={<InventariosCabFormPage />} />
                  <Route path="inventarios/new/:id" element={<InventariosCabFormPage />} />

                  <Route path="existencias" element={<ArticulosDepositoPage />} />

                  <Route path="descuentos" element={<DescuentosPage />} />
                  <Route path="descuentos/new" element={<DescuentosFormPage />} />
                  <Route path="descuentos/new/:id" element={<DescuentosFormPage />} />

                  <Route path="roles" element={<RolesPage />} />
                  <Route path="roles/new" element={<RolesFormPage />} />
                  <Route path="roles/new/:id" element={<RolesFormPage />} />

                  <Route path="sucursales" element={<SucursalesPage />} />
                  <Route path="sucursales/new" element={<SucursalesFormPage />} />
                  <Route path="sucursales/new/:id" element={<SucursalesFormPage />} />

                  <Route path="depositos" element={<DepositosPage />} />
                  <Route path="depositos/new" element={<DepositosFormPage />} />
                  <Route path="depositos/new/:id" element={<DepositosFormPage />} />

                  <Route path="visitas" element={<VisitasPage />} />
                  <Route path="visitas/new" element={<VisitasFormPage />} />
                  <Route path="visitas/new/:id" element={<VisitasFormPage />} />
                  <Route path="visitasmaps" element={<VisitasMapsPage />} />  
                  
                  <Route path="theme" element={<ThemePage />} />
                  <Route path="theme/new" element={<ThemeFormPage />} />
                  <Route path="theme/new/:id" element={<ThemeFormPage />} />

                  <Route path="*" element={<LoginPage />} />
                </Routes>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default AppRoutes;